import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-course-completion-popover',
  templateUrl: './course-completion-popover.component.html',
  styleUrls: ['./course-completion-popover.component.css']
})
export class CourseCompletionPopoverComponent implements OnInit {
  isGenerateCompletionCertificate: boolean = false;
  firstName: string;
  courseTitle: string;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
  }

}
